<div class="row">
<div class="w-full" style="border-top: 1px solid #999">
  <div class="col-2">
    <label for="formGroupExampleInput"><small>KV-Nummer</small></label>
    <input type="text" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['order_number'].errors }" id="order_number" name="order_number" formControlName="order_number">
  
  </div>
</div>
</div>